import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

export default function Copyright() {
  return (
    <MKBox mt={4} borderTop="1px solid #ccc" pt={2} textAlign="center">
      <MKTypography variant="caption">
        © {new Date().getFullYear()} Matrix-180. All rights reserved.
      </MKTypography>
    </MKBox>
  );
}
